// extracted by mini-css-extract-plugin
export default {"title":"detail_title__ZkbyA","value":"detail_value__mxM4I"};